import { getRecoil, setRecoil } from 'recoil-nexus';

import { getSessionClientId, initSocket, setRehydration, socket } from 'lib/clients/socket';

import state from 'components/state';

import initializeUserSocket from './initializeUserSocket';

export default ({ sessionToken, sessionClientId, type = 'user' }) => {
  try {
    const socketState = getRecoil(state.socketState);
    if (socketState?.connected || !sessionToken) {
      return;
    }

    initSocket();
    setRehydration(true);

    switch (type) {
      case 'user':
        initializeUserSocket(sessionToken, sessionClientId || getSessionClientId());
        break;
      case 'kiosk':
        initializeUserSocket(sessionToken);
        break;
      default:
        console.log('Socket type missing. Please specify the socket type');
    }

    setRecoil(state.socketState, socket);
  } catch (error) {
    console.error('Socket init failed:', error);
  }
};
